import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import type {
  IUserMePhoneNumberChangeDto,
  IUserMePhoneNumberChangeResponse,
} from "@api/users/me/phoneNumberChange/types";
import { complete } from "@api/users/me/phoneNumberChange/complete/api";

const postApis = createPostApi<
  IApiResponse<IUserMePhoneNumberChangeResponse>,
  IPathBaseParam,
  IUserMePhoneNumberChangeDto
>("users.me.phoneNumberChange");

export const phoneNumberChange = {
  ...postApis,
  complete,
};
